'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./index.scss');

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _ButtonClear = require('../button/ButtonClear');

var _ButtonClear2 = _interopRequireDefault(_ButtonClear);

require('antd/lib/mentions/style/index.css');

var _UtilApi = require('../utils/UtilApi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mentions = (0, _component2.default)(function () {
  return import("antd/lib/mentions");
});

var Option = Mentions.Option;

var IDMention = function (_BaseComponent) {
  (0, _inherits3.default)(IDMention, _BaseComponent);

  function IDMention(props) {
    (0, _classCallCheck3.default)(this, IDMention);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDMention.__proto__ || (0, _getPrototypeOf2.default)(IDMention)).call(this, props));

    _this.onClear = function () {
      _this.setValue('');
    };

    _this.handleChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      _this.setValue(value);
    };

    _this.handleBlur = function () {
      _this.Placeholder && _this.Placeholder.show();
      var onBlur = _this.props.onBlur;

      onBlur && onBlur(true);
    };

    _this.handleFocus = function (event) {
      _this.Placeholder && _this.Placeholder.hidden();
      _this.props.onFocus && _this.props.onFocus(event);
    };

    _this.handleSelect = function (obj, prefix) {
      if (_this.props.hidePrefix) {
        setTimeout(function () {
          var val = _this.state.value;
          if (val) {
            val = val.replace(prefix + obj.value, obj.value);
            _this.setValue(val);
          }
        }, 500);
      }
    };

    _this.state = {
      isFocus: false,
      value: props.value || props.defaultValue,
      data: (0, _UtilApi.getProxy)(props) ? [] : _this.convertData(props.data)
    };
    _this.dataTestID = 'mention';
    _this.inputType = 'mention';
    return _this;
  }

  (0, _createClass3.default)(IDMention, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var data = nextProps.data,
          value = nextProps.value;

      var nextProxy = (0, _UtilApi.getProxy)(nextProps);
      var preProxy = (0, _UtilApi.getProxy)(this.props);

      var diffValue = false;
      var diffUrl = false;
      var diffData = false;

      if (!_lodash2.default.isEqual(nextProxy, preProxy)) {
        diffUrl = true;
      }

      if (!_lodash2.default.isEqual(value, this.props.value)) {
        diffValue = true;
      }
      if (!_lodash2.default.isEqual(data, this.props.data)) {
        diffData = true;
      }

      if (diffUrl) {
        this.loadData(nextProxy, function (data) {
          _this2.setState({
            data: data,
            value: value || ''
          });
        });
      } else if (diffData) {
        this.setState({
          value: diffValue ? value : this.state.value,
          data: this.convertData(data)
        });
      } else if (diffValue) {
        this.setState({ value: value });
      }
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      var _this3 = this;

      this.setState({ value: value || '' }, function () {
        _this3.props.onChange && _this3.props.onChange(value);
      });
    }
  }, {
    key: 'convertData',
    value: function convertData(data) {
      var valueKey = this.props.valueKey;

      if (!valueKey) {
        return data;
      }
      var newData = [];
      _lodash2.default.forEach(data, function (item) {
        newData.push(item[valueKey]);
      });
      return newData;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      var proxy = (0, _UtilApi.getProxy)(this.props);
      if (proxy) {
        this.loadData(proxy, function (data) {
          _this4.setState({
            data: data
          });
        });
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(proxy, callback) {
      var _this5 = this;

      var _props = this.props,
          method = _props.method,
          params = _props.params,
          valueKey = _props.valueKey,
          headers = _props.headers;

      var config = {};
      if (_lodash2.default.isString(proxy)) {
        (0, _UtilApi.setConfigAxios)(config, { proxy: proxy, method: method, params: params, headers: headers });
      } else {
        (0, _UtilApi.setConfigAxios)(config, proxy);
      }

      (0, _axios2.default)(config).then(function (res) {
        if (res.status === 200) {
          var data = [];
          var options = [];
          if (_lodash2.default.isFunction(proxy.loadCallback)) {
            options = proxy.loadCallback(res);
          } else {
            options = _lodash2.default.get((0, _UtilApi.getRootProperty)(_this5.props), []);
          }
          _lodash2.default.forEach(options, function (item) {
            data.push(item[valueKey]);
          });
          callback && callback(data);
        }
      }).catch(function () {});
    }
  }, {
    key: 'getDataTestId',
    value: function getDataTestId() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

      return this.props.dataTestID || this.dataTestID + '-' + prefix;
    }
  }, {
    key: 'render',
    value: function render() {
      // if (!this.props.fromIDInput) {
      //   throw new Error(`Vui lòng sử dụng <IDInput type="${this.inputType}" />`);
      // }

      var _props2 = this.props,
          disabled = _props2.disabled,
          className = _props2.className,
          style = _props2.style,
          prefix = _props2.prefix,
          readOnly = _props2.readOnly,
          isClearable = _props2.isClearable;
      var _state = this.state,
          value = _state.value,
          data = _state.data;

      var MOCK_DATA = (0, _defineProperty3.default)({}, prefix, data);

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)('body-wrap mentions', className, { 'input-disabled': disabled }),
          style: (0, _extends3.default)({}, style)
        },
        this.renderIcon('before'),
        _react2.default.createElement(
          Mentions,
          {
            style: {
              flex: 1,
              border: 0,
              padding: 10,
              height: '100%',
              outline: 0,
              background: 'transparent'
            },
            autoFocus: this.props.autoFocus,
            placeholder: '',
            prefix: [prefix],
            onChange: this.handleChange,
            onSelect: this.handleSelect,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            disabled: disabled,
            value: value,
            readOnly: readOnly
          },
          (MOCK_DATA[prefix] || []).map(function (value) {
            return _react2.default.createElement(
              Option,
              { key: value, value: value },
              value
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { style: {
              display: disabled ? 'none' : 'flex',
              alignItems: 'center',
              height: '100%'
            }
          },
          value && isClearable ? _react2.default.createElement(_ButtonClear2.default, { onClick: this.onClear }) : null,
          this.renderIcon('after'),
          this.renderPlaceholder()
        )
      );
    }
  }]);
  return IDMention;
}(_BaseComponent3.default);

exports.default = IDMention;


IDMention.defaultProps = {
  iconCls: '',
  iconType: "edit",
  isClearable: true,
  visibleIcon: true,
  disabled: false,
  iconAlign: 'after',
  placeholder: 'Input...',
  rootProperty: 'data.results'
};